import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../utils/authContext";

const MatrimonyProtectedRoutes = () => {
  const { isMatrimonyLoggedIn, initialized } = useAuth();
  const location = useLocation();

  // 1. Wait until we've read localStorage
  if (!initialized) {
    return null; 
  }

  if (!isMatrimonyLoggedIn) {
    return (
      <Navigate
        to="/matrimony-login"
        replace
        state={{ from: location }}
      />
    );
  }

  return <Outlet />;
};

export default MatrimonyProtectedRoutes;
